import { render, staticRenderFns } from "./wide-search.vue?vue&type=template&id=54c9733b&"
import script from "./wide-search.vue?vue&type=script&lang=js&"
export * from "./wide-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "wide-search.vue"
export default component.exports